/**
 * Remove legacy service workers that cache index.html / assets with cache-first.
 * SW registration is disabled in production, but older deployments left registrations
 * that cause stale chunk references (blank pages + 404 on lazy routes).
 */
export async function purgeLegacyServiceWorker(): Promise<void> {
  if (typeof window === 'undefined') return

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map((registration) => registration.unregister()))
  }

  if ('caches' in window) {
    const keys = await caches.keys()
    await Promise.all(
      keys
        .filter((name) => name.startsWith('numera-'))
        .map((name) => caches.delete(name))
    )
  }
}
